{
  "carrierLabel": "承運公司",
  "searchPlaceholder": "依名稱搜尋",
  "selectAsCarrier": "選擇「{name}」作為承運商",
  "typeToSearch": "輸入以搜尋公司"
}
